define('v3/Pages/Settings/ViewModels/SubjectWebApps.ViewModel',[
	'knockout',
	'jquery',
	'lodash',
	'v3/Common/Services/Frontend/Frontend.Service',
	'v3/Pages/Settings/Services/SubjectWebApps.Backend',
	'module',
	'v3/FromV2/localStorageV3Service',
	'env',
	'knockout-validation',
	'knockout-track-changes',
	'v3/FromV2/utils'
], function (ko, $, _, frontend, backend, module, localStorageV3Service, env) {
	var required = {
		trackChange: true,
		required: { message: Strings.Required }
	};

	var maxLength = {
		maxLength: {
			params: 50,
			message: Strings.MaxLengthIsExeeded
		}
	};

	var classId = env.userInfo.classId;

	var urlValidator = function (val) {
		return !val || val.toString().match(/^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i) !== null;
	};

	var maxSize = 5000000; // 10000000 bytes -> 5 mb
	var acceptedFileExtensions = [
		'image/jpeg',
		'application/pdf',
		'image/png',
		'image/gif',
		'text/plain'
	];

	function WebAppModel (vm, isEdit) {
		var self = this;
		ko.validation.init({
			insertMessages: true,
			decorateInputElement: true,
			errorElementClass: 'validationElement'
		});

		if (!isEdit) {
			vm = {
				subjectWebAppId: 0,
				webAppName: '',
				url: '',
				urlSigned: '',
				isFile: false,
				webAppInfo: '',
				fileName: '',
				isSnappetWebApp: false,
				iconUrl: ''
			};
		}

		self.id = vm.subjectWebAppId;
		self.subject = ko.observable();

		self.webAppName = ko.observable(vm.webAppName).extend($.extend({}, required, maxLength));
		self.webAppInfo = ko.observable(vm.webAppInfo).extend({ trackChange: true });

		self.isFile = ko.observable(vm.isFile);
		self.iconUrl = vm.iconUrl;
		self.url = ko.observable(vm.url).extend($.extend({}, {
			trackChange: true,
			required: {
				message: Strings.Required,
				onlyIf: function () { return self.isFile() === false; }
			}
		}, {
			validation: {
				validator: urlValidator,
				message: Strings.UrlIsInvalid,
				onlyIf: function () { return self.isFile() === false; }
			}
		}));

		self.urlSigned = ko.observable(vm.urlSigned);
		self.urlToNavigate = ko.computed(function () {
			if (self.url.isDirty()) { return self.url(); }
			return self.urlSigned() || self.url();
		});

		self.fileElement = ko.observable(vm.fileElement).extend($.extend({}, {
			trackChange: true,
			required: {
				message: Strings.Required,
				onlyIf: function () {
					return self.isFile() === true;
				}
			},
			validation: {
				validator: function (val) {
					if (!val || !val.data) {
						return true;
					}

					if (acceptedFileExtensions.indexOf(val.data.type) === -1) {
						this.message = Strings.FileIsUnsupported;
						return false;
					}
					if (maxSize < val.data.size) {
						this.message = Strings.Upload_Validation_MaxFileSizeInMB.formatEncodeArguments(maxSize / 1000000);
						return false;
					}

					return true;
				},
				message: Strings.FileIsUnsupported
			}
		}));
		self.fileName = ko.observable(vm.fileName);
		self.acceptedTypes = ['image/*', '.txt', '.pdf'];
		self.isEdit = isEdit || false;
		self.isActive = ko.observable(vm.isActive);
		self.isSnappetWebApp = ko.observable(vm.isSnappetWebApp);
		self.subjects = ko.observableArray();

		self.cancel = function () {
			self.modal.close();
		};
		self.toggleWebAppType = function (isFile) {
			self.isFile(isFile);
		};
		self.toggle = function () {
			var model = {
				SubjectWebAppId: ko.unwrap(self.id),
				SubjectId: self.subject().id,
				SubjectGroupId: self.subject().subjectGroupId,
				IsActive: self.isActive(),
				ClassId: classId
			};

			backend.toggleWebApp(model);
			return true;
		};
		self.save = function () {
			var validationErrors = ko.validation.group([self.webAppName, self.url, self.fileElement], { deep: true });

			if (validationErrors().length > 0) {
				validationErrors.showAllMessages(true);
				return;
			}

			var fileElement;
			var fileName = '';
			if (self.isFile() === true && self.fileElement() != null) {
				if (urlValidator(self.fileElement())) {
					// update no changes and file is already uploaded.
					fileElement = self.fileElement();
					fileName = self.fileName();
				} else {
					if (self.fileElement().file != null) {
						fileElement = self.fileElement().file;
						fileName = self.fileElement().data.name;
					}
				}
			}

			var model = {
				SubjectWebAppId: ko.unwrap(self.id),
				Url: ko.unwrap(self.url),
				WebAppName: ko.unwrap(self.webAppName),
				WebAppInfo: ko.unwrap(self.webAppInfo),
				SubjectId: self.subject().id,
				SubjectGroupId: self.subject().subjectGroupId,
				IsFile: self.isFile(),
				FileElement: fileElement,
				FileName: fileName
			};

			if (self.id > 0 && isEdit === true) {
				self.modal.close(backend.updateWebApp(model));
			} else {
				self.modal.close(backend.addWebApp(model));
			}

			frontend.notification.success({
				text: Strings.WebappsSavedSuccesfully
			});
		};

		self.remove = function (webApp) {
			frontend.confirm.show({
				title: Strings.WebAppPage_Remove_Title,
				content: Strings.SubjectWebAppPage_Remove_App.formatEncodeArguments(webApp.webAppName())
			})
				.then(function () {
					self.modal.close(backend.deleteWebApp(webApp.id));
					frontend.notification.success({
						text: Strings.WebappsSavedDeleted
					});
				})
				.fail(function () {
					frontend.mask.hide();
				});
		};

		self.reset = function (vm) {
			self.subject(ko.unwrap(vm.subject));
			self.webAppName(ko.unwrap(vm.webAppName));
			self.webAppInfo(ko.unwrap(vm.webAppInfo));
			self.isFile(ko.unwrap(vm.isFile));
			self.url(ko.unwrap(vm.url));
		};

		self.disabled = ko.computed(function () {
			var validationErrors = ko.validation.group([self.webAppName, self.url, self.fileElement], { deep: true });
			return validationErrors().length > 0;
		});
	};

	function WebAppViewModel (options) {
		var self = this;

		self.sortBy = ko.observable('webAppName');
		self.sortDirection = ko.observable('asc');

		self.navBackButtonParams = options.navBackButtonParams;

		self.data = ko.observableArray().extend({ loading: true });

		self.subjects = ko.observableArray();
		self.selectedSubject = ko.observable();
		self.selectedSubject.subscribe(function (subject) {
			self.filter(subject.id, subject.subjectGroupId);
			localStorageV3Service.setSubjectIdByClassIdLocalStorage(subject.id, classId);
		});

		self.totalActive = ko.pureComputed(function () {
			var total = 0;

			ko.utils.arrayForEach(self.data(), function (item) {
				if (item.isActive()) {
					total += 1;
				}
			});
			return '<strong>{0}</strong>/{1}'.formatEncodeArguments(total, self.data().length);
		});

		self.showJumboTron = ko.computed(function () {
			return (!ko.computedContext.isInitial() && self.data() < 1) ||
				(ko.computedContext.isInitial() && self.data() === 0);
		});

		self.openAppModal = function (isEdit, vm) {
			var viewModel = (isEdit) ? vm : new WebAppModel(null, isEdit);
			viewModel.isEdit = isEdit;
			viewModel.subjects(self.subjects());
			viewModel.subject(self.selectedSubject());

			frontend.modal.show({
				viewModel: viewModel,
				template: 'webAppModal',
				icon: viewModel.isFile() ? 'Document' : 'Browser',
				title: (isEdit) ? Strings.Edit + ' ' + ko.unwrap(vm.webAppName) : Strings.SubjectWebAppPage_Add_Record,
				width: 588
			}).then(function (options) {
				options.done(function () {
					self.selectedSubject(viewModel.subject());
				});
			}).fail(function () {
				viewModel.reset(vm);
			});
		};

		self.moreContext = {
			placement: 'se',
			menu: [{
				text: 'Settings',
				click: function (vm) {
					vm.popover.close();
					self.openAppModal(true, vm);
				},
				arrow: true
			}, {
				text: Strings.SubjectWebAppPage_Remove_Title,
				className: 'btn-txt-delete',
				click: function (vm) {
					vm.popover.close();
				}
			}]
		};

		self.getSubjects = function () {
			backend.getSubjects()
				.then(function (subjects) {
					var subjectsModel = _.map(subjects,
						function (subject) {
							return new SubjectModel(subject);
						});

					if (subjectsModel.length > 0) {
						self.subjects(subjectsModel);
						var subjectId = localStorageV3Service.getSubjectIdByClassIdLocalStorage(classId);
						if (subjectId) {
							var subject = ko.utils.arrayFirst(subjectsModel, function (x) {
								return x.id === subjectId;
							});
							self.selectedSubject(subject);
						}
					}
				});
		};

		self.filter = function (subjectId, subjectGroupId) {
			if (subjectId) {
				frontend.mask.show();

				backend.getWebApps(subjectId, subjectGroupId)
					.then(function (webapps) {
						var apps = _.map(webapps,
							function (webapp) {
								var viewModel = new WebAppModel(webapp, true);
								viewModel.subject(self.selectedSubject());
								return viewModel;
							});
						self.data(apps);
						setTimeout(function () {
							frontend.mask.hide();
						}, 1000);
					});
			}
		};

		self.getSubjects();
	};

	function SubjectModel (subject) {
		this.id = subject.subjectId;
		this.subjectGroupId = subject.subjectGroupId;
		this.name = subject.name;
		this.optionGroup = subject.active === true ? Strings.ActiveSubjects : Strings.OtherSubjects;
	};

	return WebAppViewModel;
}
);
